export enum Accumulator {
  Count = 'count',
  Sum = 'sum',
  Mean = 'mean',
  StandardDeviation = 'standard_deviation',
  Min = 'minimum',
  Max = 'maximum',
}

export enum ColumnType {
  Int = 'int',
  Float = 'float',
  String = 'string',
  Bool = 'bool',
}

export enum DataViewExecutionState {
  Completed = 'completed',
  Failed = 'failed',
  Processing = 'processing',
  Queued = 'queued',
}

export enum ExportFormat {
  CSV = 'csv',
  TSV = 'tsv',
  JSON = 'json',
  JsonFlat = 'json-flat',
  JsonRowColumn = 'json-row-column',
  NewlineDelimitedJson = 'ndjson',
}

export enum DataViewTab {
  Views = 'views',
  Shared = 'shared',
  Queue = 'queue',
}
